
<template>
	<div id="checkinPage">
		<div class="view-area" v-if='!this.loading && !this.intro && this.$user.patient'>
			<form id="checkIn" class="needs-validation was-validated" novalidate @submit="checkForm" method="post">
				<div class="container">
					<div class="card clinic-logo">
						<img :src="this.$user.patient.logo" /> 
					</div>
					<div class="card mt-2 border-0 data-intro" v-if="!start">
						  <div class="card-body">
						    <h5 class="card-title">{{this.$user.patient.clinic_name}}</h5>
						    <p class="card-text"> Olá, <i>{{this.$user.patient.name}}</i> </p>
						    <p>
						     Voc&ecirc; possui um exame agendado conosco. Para um atendimento mais rápido pedimos a gentileza de
						     <br>
						     <u>confirmar seu cadastro</u>. </p>
						    <div class='convenio-particular'>
							    <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="setMode('convenio')" >Convênio</a>
							    <a href="javascript:void(0)" class="btn btn-primary" v-on:click="setMode('particular')" >Particular</a>
							</div>
						  </div>
					</div>
					<div  v-if="finished">
						<div class="check_mark">
						  <div class="sa-icon sa-success animate">
						    <span class="sa-line sa-tip animateSuccessTip"></span>
						    <span class="sa-line sa-long animateSuccessLong"></span>
						    <div class="sa-placeholder"></div>
						    <div class="sa-fix"> </div>
						  </div>
						</div>	
						<div class="check_text">
						  	Check-in realizado com sucesso! Agora basta dirigir-se à clínica na data e horário agendados e realizar seu exame com conforto e agilidade!
						</div>		

						<div v-if="patientData.preparo && patientData.preparo.length > 0" class="mt-2">
							<hr>
							<h4 class="text-center"> Observações </h4>
							<div class="card shadow-sm" v-for="(preparo, index) in patientData.preparo" :key="index">
								<div class="card-body" v-if="preparo" v-html="preparo"></div>
								<div class="card-body" v-if="!preparo">Nenhum preparo necess&aacute;rio.</div>
							</div>
						</div>

					</div>


					<div v-if="!finished ">
						<transition name="fade">
							<div class="card shadow-sm mt-2 border-0 data-checkin" v-if="start">
								<div class="card-body">
									<p> Informe seus dados </p>
									<div class="alert alert-danger" v-if="errors.length">
										<b>Por favor, verifique os seguintes erros(s):</b>
										<ul>
											<li v-for="(error, index) in errors" v-bind:key="index">{{ error }}</li>
										</ul>
									</div>

									<div class="alert" :class="{'alert-danger': response.error, 'alert-success': ! response.error, 'alert-info' : response.loading}" v-if="response.message">{{ response.message}}</div>

									<div class="input-control">
										<input autocomplete="off" type="text" placeholder="Nome Completo" class="form-control" v-if="this.$user" required  v-model="patientData.name">
										<span class="material-icons"></span>
									</div>

									<div class="input-control">
										<input autocomplete="off" type="birthdate" placeholder="Data de Nascimento" class="form-control" v-if="this.$user" v-mask="'##/##/####'" required v-model="patientData.birthdate">
										<span class="material-icons"></span>
									</div>

									<div class="input-control">
										<select class="form-control" v-model="patientData.sex">
											<option value="" disabled selected>Selecione seu Sexo</option>
											<option value="F"> Feminino </option>
											<option value="M"> Masculino </option>
										</select>
										<span class="material-icons"></span>
									</div>

									<div class="input-control">
										<input autocomplete="off" type="cpf" class="form-control" v-if="this.$user" v-mask="'###.###.###-##'" required placeholder="CPF" v-model="patientData.cpf">
										<span class="material-icons"></span>
									</div>

									<div class="input-control">
										<input autocomplete="off" type="cel"  class="form-control" v-mask="['(##) ####-####', '(##) #####-####']" placeholder="Celular" masked="true" v-model="patientData.cel">
										<span class="material-icons"></span>
									</div>

									<div class="input-control">
										<input autocomplete="off" type="number"  class="form-control"  placeholder="CEP"  v-on:blur="searchCep" v-model="patientData.cep">
										<span class="material-icons"></span>
									</div>		

									<div class="input-control">
										<input autocomplete="off" type="text"  class="form-control"  placeholder="UF"  v-model="patientData.uf">
										<span class="material-icons"></span>
									</div>

									<div class="input-control">
										<input autocomplete="off" type="text"  class="form-control"  placeholder="Cidade"  v-model="patientData.city">								
										<span class="material-icons"></span>
									</div>				

									<div class="input-control">
										<input autocomplete="off" type="text"  class="form-control"  placeholder="Endereço"  v-model="patientData.address">
										<span class="material-icons"></span>
									</div>

									<div class="input-control">
										<input autocomplete="off" type="number"  class="form-control"  placeholder="Número"  v-model="patientData.address_number">
										<span class="material-icons"></span>
									</div>

								</div>
								<div class="card-body">
									<p>Clique nos itens abaixo para enviar foto</p>
									<div class="input-control input-upload" :class="{'valid' : arquivo.identidade}">
										<label for="identidade"><i class="material-icons">camera_alt</i> Identidade </label>
										<input type="file" class="form-control-file" id="identidade" v-on:change="uploadFile($event,'identidade')">
									</div>

									<div class="input-control input-upload" :class="{'valid' : arquivo.carteirinha}" v-if="mode=='convenio'">
										<label for="carteirinha"><i class="material-icons">camera_alt</i> Carteirinha do convênio</label>
										<input type="file" class="form-control-file" id="carteirinha" v-on:change="uploadFile($event,'carteirinha');">
									</div>

									<div class="input-control input-upload" :class="{'valid' : arquivo.guia}" v-if="mode=='convenio'">
										<label for="guia"><i class="material-icons">camera_alt</i> Guia do convênio</label>
										<input type="file" class="form-control-file" id="guia" v-on:change="uploadFile($event,'guia')">
									</div>

									<div class="input-control input-upload" :class="{'valid' : arquivo.pedidoFrente}">
										<label for="pedido-medico-frente"><i class="material-icons">camera_alt</i> Pedido (Frente)</label>
										<input type="file" class="form-control-file" id="pedido-medico-frente" v-on:change="uploadFile($event,'pedido-frente')">
									</div>

									<div class="input-control input-upload" :class="{'valid' : arquivo.pedidoVerso}">
										<label for="pedido-medico-verso"><i class="material-icons">camera_alt</i> Pedido (Verso)</label>
										<input type="file" class="form-control-file" id="pedido-medico-verso" v-on:change="uploadFile($event,'pedido-verso')">
									</div>
								</div>
                <div class="card-body">
                  <div class="input-control">
                    <div class="form-check form-check-inline" style="margin-left:10px;color:#212529 !important;">
                      <p>
                      <input class="form-check-input" type="checkbox" id="inlineCheckbox1" value="option1">
                      <label class="form-check-label" for="inlineCheckbox1" style="color:#212529">Aceito termos e condições. Clique <a href="#"><u>aqui</u></a> para saber mais. </label>
                      </p>
                    </div>
                    </div>
                </div>
								<div class="border-top p-3 confirm-checkin" >
									<button class="btn btn-primary" type="submit">
										<i class="fas fa-check-circle"></i>
										Confirmar! 
									</button>
								</div>
							</div>
						</transition>
					</div>
				</div>
			</form>
		</div>
		<div class="loading" v-if='this.loading'>
			<app-loader></app-loader>
			<div>Enviando check-in...</div>
		</div>
		<div class="loading" v-if='this.intro'>
			<app-loader></app-loader>
			<div>Carregando...</div>
		</div>
	</div>
</template>


<script>
import { Auth, Patient } from "@/services";
import tinycolor from "tinycolor2";
import Compress from "compress.js";

let ga = null;
let finished = false;

window.onbeforeunload = function() {
  if (ga && !finished)
    ga.event({
      eventCategory: "checkin",
      eventAction: "checkin",
      eventLabel: `Checkin CANCELADO - ${this.$user.patient.clinic_name}`
    });
};

export default {
  name: "checkIn",
  data() {
    return {
      patient_attachments: [],
      schedule_attachments: [],
      schedules: null,
      arquivo: {
        pedido: false,
				carteirinha: false,
				guia: false,
        pedidoFrente: false,
        pedidoVerso: false,
        identidade: false
      },
      patientData: {
        uf: null,
        city: null
      },
      start: false,
      mode: false,
      finished: false,
      response: {
        error: false,
        message: null,
        loading: false
      },
      loading: false,
      intro: true,
      errors: []
    };
  },
  methods: {
    checkForm(e) {
      this.loading = true;
      e.preventDefault();

      // var schedules = JSON.parse(JSON.stringify(this.patientData.schedules));
      // delete this.patientData['schedules'];

      var schedules = JSON.parse(JSON.stringify(this.schedules));
      if (this.patientData.birthdate.indexOf("/") !== -1) {
        this.patientData.birthdate = this.patientData.birthdate
          .split("/")
          .reverse()
          .join("-");
      }

      var myPat = this.patientData;
      delete myPat["key"];
      var obj = {
        protocol: this.patientData.protocol,
        password: this.patientData.password,
        schedules: schedules,
        patient: myPat
      };
      obj.patient_attachments = this.patient_attachments;
      obj.schedule_attachments = this.schedule_attachments;

      Patient.checkIn(obj)
        .then(result => {
          this.finished = true;
          finished = true;
          this.loading = false;
          localStorage.setItem("refresh", "0");

          if (this.$ga)
            this.$ga.event({
              eventCategory: "checkin",
              eventAction: "checkin",
              eventLabel: `Checkin FINALIZADO - ${
                this.$user.patient.clinic_name
              }`
            });
        })
        .catch(() => (this.loading = false));
    },
    uploadFile(evt, dest) {
      var upload = evt.target.files[0];
      const compress = new Compress();
      const files = evt.target.files;
      compress
        .compress([upload], {
          size: 1, // the max size in MB, defaults to 2MB
          quality: 0.2, // the quality of the image, max is 1,
          maxWidth: 1920, // the max width of the output image, defaults to 1920px
          maxHeight: 1920, // the max height of the output image, defaults to 1920px
          resize: true // defaults to true, set false if you do not want to resize the image width and height
        })
        .then(data => {
          data.forEach(myfile => {
            var file_object = {
              name: dest,
              mime_type: myfile.ext,
              content: myfile.data
						};
						
						console.log(file_object);
						
            switch (dest) {
              case "guia":
                this.schedule_attachments.push(file_object);
                this.arquivo.guia = true;
                break;
              case "pedido-frente":
                this.schedule_attachments.push(file_object);
                this.arquivo.pedidoFrente = true;
                break;
              case "pedido-verso":
                this.schedule_attachments.push(file_object);
                this.arquivo.pedidoVerso = true;
                break;
              case "carteirinha":
                this.patient_attachments.push(file_object);
                this.arquivo.carteirinha = true;
                break;
              case "identidade":
                this.patient_attachments.push(file_object);
                this.arquivo.identidade = true;
                break;
						}
						
						console.log(this.arquivo);
          });
        })
        .catch(e => {
          console.log(e);
        });
    },
    searchCep() {
      return true;
      var that = this;
      var cep = this.patientData.cep.replace(/\D/g, "");
      var address_content = Patient.getCep(cep).then(response => {
        this.patientData.uf = response.data.uf;
        this.patientData.city = response.data.localidade;
        this.patientData.address = response.data.logradouro;
      });
    },
    setMode(type) {
      // e.preventDefault();
      this.start = true;
      this.mode = type;
    },
    authUser() {}
  },
  created() {
    ga = this.$ga;

    var data = JSON.parse(atob(this.$route.params.data));

    Auth.checkRegistry(data).then(() => {
      Auth.loginPatient({
        login: data.protocol.replace("-", ""),
        password: data.password.replace("-", ""),
        loginMethod: "PROTOCOLO"
      })
        .then(response => {
          localStorage.setItem("Authorization", response.data.token);
          Auth.setToken(response.data.token);

          this.patientData = data;
          Patient.getData().then(response => {
            this.schedules = response.data.schedules;
            if (response.data.birthdate.length == 10) {
              this.patientData.birthdate = response.data.birthdate
                .split("-")
                .reverse()
                .join("/");
            }

            Auth.setAuthenticated().then(response => {
              if (this.$ga)
                this.$ga.event({
                  eventCategory: "login",
                  eventAction: "checkin-login",
                  eventLabel: `Autenticação Checkin OK - ${
                    this.$user.patient.clinic_name
                  }`
                });

              Auth.setColorPallete()
                .getPalette()
                .then(pallete => {
                  let colors = {
                    primary: pallete.Vibrant.getHex(),
                    secondary: pallete.LightVibrant
                      ? pallete.LightVibrant.getHex()
                      : pallete.LightMuted
                        ? pallete.LightMuted.getHex()
                        : pallete.Muted.getHex(),
                    muted: pallete.DarkVibrant
                      ? pallete.DarkVibrant.getHex()
                      : pallete.DarkMuted.getHex()
                  };

                  let css = `										
								.btn-primary {
									background-color: ${colors.primary} !important;
									color: ${tinycolor(colors.primary).isLight ? "#fff" : "#333"} !important;
									border-color: transparent !important;
								}

								.input-upload.valid label {
									background-color: ${colors.muted} !important;
									color: ${tinycolor(colors.muted).isLight ? "#fff" : "#333"} !important;
									border-color: transparent !important;
								}

								.btn-secondary {
									background-color: ${colors.muted} !important;
									color: ${tinycolor(colors.muted).isLight ? "#fff" : "#333"} !important;
									border-color: transparent !important;
								}
								
								.Loader .Bar {
									background: ${pallete.Vibrant.getHex()} !important;
								}

								.app-menu .material-icons {
									color:${colors.primary};
								}
							`;

                  var head = document.getElementsByTagName("head")[0];
                  var s = document.createElement("style");
                  s.setAttribute("type", "text/css");

                  if (s.styleSheet) {
                    s.styleSheet.cssText = css;
                  } else {
                    s.appendChild(document.createTextNode(css));
                  }

                  head.appendChild(s);
                });

              this.$nextTick(function() {
                this.intro = false;
              });
            });
          });
        })
        .catch(error => {
          this.credentials.callback.error = true;
          this.credentials.callback.message = this.$t('UnauthorizedAccessTryAgain');
          window.location.reload();
        });
    });

    setTimeout( () => {
          Auth.checkRegistry(data).then(() => {
            Auth.loginPatient({
              login: data.protocol.replace("-", ""),
              password: data.password.replace("-", ""),
              loginMethod: "PROTOCOLO"
            })
              .then(response => {
                localStorage.setItem("Authorization", response.data.token);
                Auth.setToken(response.data.token);

                this.patientData = data;
                Patient.getData().then(response => {
                  this.schedules = response.data.schedules;
                  if (response.data.birthdate.length == 10) {
                    this.patientData.birthdate = response.data.birthdate
                      .split("-")
                      .reverse()
                      .join("/");
                  }

                  Auth.setAuthenticated().then(response => {
                    if (this.$ga)
                      this.$ga.event({
                        eventCategory: "login",
                        eventAction: "checkin-login",
                        eventLabel: `Autenticação Checkin OK - ${
                          this.$user.patient.clinic_name
                        }`
                      });

                    Auth.setColorPallete()
                      .getPalette()
                      .then(pallete => {
                        let colors = {
                          primary: pallete.Vibrant.getHex(),
                          secondary: pallete.LightVibrant
                            ? pallete.LightVibrant.getHex()
                            : pallete.LightMuted
                              ? pallete.LightMuted.getHex()
                              : pallete.Muted.getHex(),
                          muted: pallete.DarkVibrant
                            ? pallete.DarkVibrant.getHex()
                            : pallete.DarkMuted.getHex()
                        };

                        let css = `										
                      .btn-primary {
                        background-color: ${colors.primary} !important;
                        color: ${tinycolor(colors.primary).isLight ? "#fff" : "#333"} !important;
                        border-color: transparent !important;
                      }

                      .input-upload.valid label {
                        background-color: ${colors.muted} !important;
                        color: ${tinycolor(colors.muted).isLight ? "#fff" : "#333"} !important;
                        border-color: transparent !important;
                      }

                      .btn-secondary {
                        background-color: ${colors.muted} !important;
                        color: ${tinycolor(colors.muted).isLight ? "#fff" : "#333"} !important;
                        border-color: transparent !important;
                      }
                      
                      .Loader .Bar {
                        background: ${pallete.Vibrant.getHex()} !important;
                      }

                      .app-menu .material-icons {
                        color:${colors.primary};
                      }
                    `;

                        var head = document.getElementsByTagName("head")[0];
                        var s = document.createElement("style");
                        s.setAttribute("type", "text/css");

                        if (s.styleSheet) {
                          s.styleSheet.cssText = css;
                        } else {
                          s.appendChild(document.createTextNode(css));
                        }

                        head.appendChild(s);
                      });

                    this.$nextTick(function() {
                      this.intro = false;
                    });
                  });
                });
              })
              .catch(error => {
                this.credentials.callback.error = true;
                this.credentials.callback.message = this.$t('UnauthorizedAccessTryAgain');
                window.location.reload();
              });
          });
    },1000)

    if (this.$ga)
      this.$ga.event({
        eventCategory: "login",
        eventAction: "checkin-login",
        eventLabel: `Autenticação Checkin`
      });
  },
  watch: {
    "$route.path": function(id) {
      console.log("trocou a rota", id);
      this.authUser();
    }
  }
};
</script>

<style lang="scss">
.loading {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 128px;
  height: 128px;
  text-align: center;

  .Loader {
    margin: 16px auto;
  }
}

@import "../../assets/_vars";

a {
  color: #333;
}

.container {
  @media screen and (max-width: $mobile) {
    padding: 0 !important;
    height: 100%;
  }
}

.clinic-logo {
  padding-top: 20px;
}

.clinic-logo img {
  display: block;
  margin: 0 auto;
}

.clinic-logo img {
  max-width: 80%;
}

.convenio-particular a {
  display: block;
  margin: 20px auto;
  min-width: 200px;
  width: 100%;
  padding: 16px;
}

.confirm-checkin {
  margin: 0 auto;
  width: 100%;
}

.confirm-checkin button {
  height: 50px;
  min-width: 200px;
  width: 100%;
  display: block;
  margin: 0 auto;
}

.check_mark {
  width: 96px;
  margin: 0 auto;
  overflow: hidden;
}

.check_text {
  padding: 10px;
  text-align: center;
}

.hide {
  display: none;
}

.sa-icon {
  width: 80px;
  height: 80px;
  border: 4px solid gray;
  -webkit-border-radius: 40px;
  border-radius: 40px;
  border-radius: 50%;
  margin: 20px auto;
  padding: 0;
  position: relative;
  box-sizing: content-box;
}

.sa-icon.sa-success {
  border-color: #4caf50;
}

.sa-icon.sa-success::before,
.sa-icon.sa-success::after {
  content: "";
  -webkit-border-radius: 40px;
  border-radius: 40px;
  border-radius: 50%;
  position: absolute;
  width: 60px;
  height: 120px;
  background: white;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.sa-icon.sa-success::before {
  -webkit-border-radius: 120px 0 0 120px;
  border-radius: 120px 0 0 120px;
  top: -7px;
  left: -33px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: 60px 60px;
  transform-origin: 60px 60px;
}

.sa-icon.sa-success::after {
  -webkit-border-radius: 0 120px 120px 0;
  border-radius: 0 120px 120px 0;
  top: -11px;
  left: 30px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
  -webkit-transform-origin: 0px 60px;
  transform-origin: 0px 60px;
}

.sa-icon.sa-success .sa-placeholder {
  width: 80px;
  height: 80px;
  border: 4px solid rgba(76, 175, 80, 0.5);
  -webkit-border-radius: 40px;
  border-radius: 40px;
  border-radius: 50%;
  box-sizing: content-box;
  position: absolute;
  left: -4px;
  top: -4px;
  z-index: 2;
}

.sa-icon.sa-success .sa-fix {
  width: 5px;
  height: 90px;
  background-color: white;
  position: absolute;
  left: 28px;
  top: 8px;
  z-index: 1;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

.sa-icon.sa-success.animate::after {
  -webkit-animation: rotatePlaceholder 4.25s cubic-bezier(0.4, 0, 1, 1)-in;
  animation: rotatePlaceholder 4.25s cubic-bezier(0.4, 0, 1, 1)-in;
}

.sa-icon.sa-success {
  border-color: transparent\9;
}

.sa-icon.sa-success .sa-line.sa-tip {
  -ms-transform: rotate(45deg) \9;
}

.sa-icon.sa-success .sa-line.sa-long {
  -ms-transform: rotate(-45deg) \9;
}

.animateSuccessTip {
  -webkit-animation: animateSuccessTip 0.75s;
  animation: animateSuccessTip 0.75s;
}

.animateSuccessLong {
  -webkit-animation: animateSuccessLong 0.75s;
  animation: animateSuccessLong 0.75s;
}

@-webkit-keyframes animateSuccessLong {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}
@-webkit-keyframes animateSuccessTip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}
@keyframes animateSuccessTip {
  0% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  54% {
    width: 0;
    left: 1px;
    top: 19px;
  }
  70% {
    width: 50px;
    left: -8px;
    top: 37px;
  }
  84% {
    width: 17px;
    left: 21px;
    top: 48px;
  }
  100% {
    width: 25px;
    left: 14px;
    top: 45px;
  }
}

@keyframes animateSuccessLong {
  0% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  65% {
    width: 0;
    right: 46px;
    top: 54px;
  }
  84% {
    width: 55px;
    right: 0px;
    top: 35px;
  }
  100% {
    width: 47px;
    right: 8px;
    top: 38px;
  }
}

.sa-icon.sa-success .sa-line {
  height: 5px;
  background-color: #4caf50;
  display: block;
  border-radius: 2px;
  position: absolute;
  z-index: 2;
}

.sa-icon.sa-success .sa-line.sa-tip {
  width: 25px;
  left: 14px;
  top: 46px;
  -webkit-transform: rotate(45deg);
  transform: rotate(45deg);
}

.sa-icon.sa-success .sa-line.sa-long {
  width: 47px;
  right: 8px;
  top: 38px;
  -webkit-transform: rotate(-45deg);
  transform: rotate(-45deg);
}

@-webkit-keyframes rotatePlaceholder {
  0% {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
    -webkit-transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
    -webkit-transform: rotate(-405deg);
  }
}
@keyframes rotatePlaceholder {
  0% {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  5% {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }
  12% {
    transform: rotate(-405deg);
    -webkit-transform: rotate(-405deg);
  }
  100% {
    transform: rotate(-405deg);
    -webkit-transform: rotate(-405deg);
  }
}

.input-control {
  position: relative;
  margin-bottom: 8px;
}

.input-upload {
  position: relative;
  background: #f5f6f4;
  color: #333;

  label {
    display: flex;
    border-radius: 3px;
    padding: 8px;
    position: relative;

    i {
      margin-right: 8px;
    }
  }

  input {
    display: none;
  }
}

.form-control {
  background: #f5f4f6;
  border: none;
  border-radius: 3px;

  + span {
    &::before {
      content: "done";
      color: #28a745;
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      margin: auto;
      width: 24px;
      height: 24px;
    }

    display: block;
    width: 32px;
    height: 32px;
    position: absolute;
    margin: auto;
    top: 0;
    right: 8px;
    bottom: 0;
  }
}

.was-validated .form-control:invalid,
.form-control.is-invalid,
.was-validated .custom-select:invalid,
.custom-select.is-invalid {
  + span {
    &::before {
      content: "warning";
      color: #dc3545;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/patient/checkinPage.vue